export default "__VITE_ASSET__DtpeT1u7__"